import { Component } from '@angular/core';

@Component({
    selector: 'app-account-create',
    templateUrl: './account-create.component.html',
    styleUrl: './account-create.component.scss',
    standalone: false
})
export class AccountCreateComponent {

}
